import { Box, Switch, Typography } from '@mui/material';
import { useState } from 'react';
import { styled } from '@mui/material/styles';
import { StyledSwitch } from './styles';
import usePlanStore from '../../../../../../../../store/planStore';

export interface OutdoorProps {
  disabledSwitch?: boolean;
  isMustHave?: boolean;
}

export default function Outdoor({
  disabledSwitch = false,
  isMustHave = false,
}: OutdoorProps) {
  const { countryForms, selectedCountry, updateOOHAvailable, resetOOHConfig } =
    usePlanStore();
  const oohConfig = countryForms[selectedCountry!]?.offline?.ooh;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    updateOOHAvailable(selectedCountry!, event.target.checked);
    if (!event.target.checked) {
      resetOOHConfig(selectedCountry!);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        borderTop: '1px solid #C7D8F9',
        borderBottom: '1px solid #C7D8F9',
        px: '10px',
      }}
    >
      <StyledSwitch
        onChange={handleChange}
        checked={isMustHave || oohConfig?.isAvailable}
        disabled={disabledSwitch}
        sx={{ mr: 1 }}
      />
      <Typography sx={{ fontWeight: 700, py: 1 }}>
        OUTDOOR (include in plan)
      </Typography>
    </Box>
  );
}
